import { render, staticRenderFns } from "./Freehand.vue?vue&type=template&id=4c6ffb5e&scoped=true&"
import script from "./Freehand.vue?vue&type=script&lang=js&"
export * from "./Freehand.vue?vue&type=script&lang=js&"
import style0 from "./Freehand.vue?vue&type=style&index=0&id=4c6ffb5e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6ffb5e",
  null
  
)

export default component.exports